import Table from "react-bootstrap/Table";
import RiskBubble from "./RiskBubble";
import SimulatedStudyPlot from "./SimulatedStudyPlot";
import { useState } from "react";

function EndpointRankTable({ endpoints, doses, doseUnit }) {
  let bubbleClassMap = {
    Sensitive: "sensitive",
    "Not Sensitive": "not-sensitive",
  };

  let [shownStudyPlot, setShownStudyPlot] = useState(null);
  return (
    <>
      <Table className="endpoint-rank-table">
        <thead>
          <tr>
            <th>Rank</th>
            <th>Organ</th>
            <th>Endpoint Name</th>
            <th>Sensitivity Score</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {endpoints.map((endpoint) => (
            <tr onClick={() => setShownStudyPlot(endpoint)}>
              <td>#{endpoint.rank} </td>
              <td>{endpoint.organ}</td>
              <td>{endpoint.endpoint}</td>
              <td>{endpoint.score.toFixed(3)}</td>
              <td>
                <RiskBubble
                  text={endpoint.class}
                  styleClass={bubbleClassMap[endpoint.class]}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {shownStudyPlot != null ? 
      <div className="studyPlotHolder">
        <div className="studyPlotHolderHeader">
          <h3>{shownStudyPlot.organ} {shownStudyPlot.endpoint}</h3>
          <div>
            <span
              style={{
                cursor: "pointer",
                fontVariationSettings:
                  "'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 36",
              }}
              className="material-symbols-rounded"
              onClick={() => setShownStudyPlot(null)}
            >
              close
            </span>
          </div>
        </div>
        {endpoints.map((endpoint) => (
          <SimulatedStudyPlot
            percentiles={endpoint.data_percentiles}
            doses={doses}
            show={endpoint == shownStudyPlot}
            doseUnit={doseUnit}
            endpoint={`${endpoint.organ}_${endpoint.endpoint}`}
          />
        ))}
      </div> : null}
    </>
  );
}

export default EndpointRankTable;
